/**
 * Toast utility functions for showing notifications
 */

// Simple toast function that works with the ToastContext
export const showToast = (message: string, type: 'success' | 'error' | 'warning' | 'info' = 'info', duration: number = 5000) => {
  // This is a simple implementation that dispatches a custom event
  // The ToastProvider will listen for these events and show toasts
  
  const event = new CustomEvent('show-toast', {
    detail: {
      title: message,
      type,
      duration,
      closable: true
    }
  });
  
  window.dispatchEvent(event);
};